var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lift-card lift-card--has-cta-button\">\n<a ng-href=\"{{$ctrl.readMoreLink}}\" class=\"lift-card__link\">\n<div class=\"lift-card__image-wrap\">\n<div class=\"lift-card__image cropped-image lozad\" ng-style=\"{'background-image':'url(' + $ctrl._serviceImage + ')'}\">\n</div>\n<div class=\"lift-card__tag\" ng-if=\"$ctrl.service.price === '0'\">\n0 €\n</div>\n</div>\n<div class=\"lift-card__content\">\n<div class=\"lift-card__heading\">{{ $ctrl.service.name }}</div>\n<p>{{$ctrl.service.description}}</p>\n</div>\n</a>\n<norm-button class=\"lift-card__cta-button\" secondary=\"true\" link=\"{{ $ctrl.reservationUrl }}\" block=\"true\" ng-if=\":: $ctrl.service.internet_reservable\">\n<span translate>Varaa aika</span>\n</norm-button>\n</div>\n";
var id1="app/services/featured-service-card.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/services/featured-service-card.tpl.html
// module id = 546
// module chunks = 5